<script setup lang="ts">
  import { differenceInDays } from 'date-fns'

  defineProps<{
    createdAt: string,
  }>()
</script>

<template>
  <span
    v-if="differenceInDays(new Date(), createdAt) < 1"
    class="text-xs ml-1 text-primary-500">
    NEW
  </span>
</template>
